<div [hidden]="item.id_file != null && file != null">
    <!-- storage upload with temp id transform flag -->
    <core-storage-files-upload 
        [multiple]="false" 
        [legacyTempId]="true"
        (response)="upload($event)"
        (onUploading)="onUploading($event)"
        [hiddenUploaded]="true">
    </core-storage-files-upload>
</div>

<div class="uplodaded" *ngIf="item.id_file != null && file != null">
    <core-storage-file-uploaded-list-item [remove]="true" (onRemove)="removeFile()" [file]="file"></core-storage-file-uploaded-list-item>
</div>

<div class="carousel-upload">
    <!-- carrousel -->
    <div *ngIf="item.id_file != null">

        <div class="carousel-upload">
            <core-helpers-box-loading *ngIf="preview == null || preview.status_code==0"></core-helpers-box-loading>
            <core-helpers-box-alert-try-again *ngIf="preview != null && preview.status_code == 2 && preview.status_code == 3" [text]="'Previews not found.'"></core-helpers-box-alert-try-again>
            <core-previews-carousel
                *ngIf="preview != null && preview.status_code==1"
                [selectedPage]="item.page_selected"
                [preview]="preview"
                (onClickPage)="selectPage($event)"
                [rotateAction]="filtersActions.rotate"
                [activateAction]="filtersActions.ignore"
                (onActivateClick)="activePage($event)"
                [deactivatePages]="getDeactivePages()"
            >
            </core-previews-carousel>
            <!--TODO CHANGE STYLE AND TEXT-->
            <div *ngIf="preview != null && preview.status_code == 3">
                <span>Oeps…..unfortunately we cannot create a preview for this file. Please try uploading a file we can handle (pdf, jpg, doc, etc).</span>
            </div>
        </div>

        <div class="crop-image" *ngIf="preview != null && preview.status_code==1" >
            <!-- ignored-->
            <div class="ignored-image">
            <core-preview-page *ngIf="getDeactivePages().includes(item.page_selected)" [page]="item.page_selected" [fileId]="file.id" [format]="'big-width'"></core-preview-page>
            </div>
            <!-- not ignored-->
            <core-file-page-filters #childComponent *ngIf="!getDeactivePages().includes(item.page_selected)" [page]="item.page_selected" [file]="file" [filters]="filtersPageSelected" (onChange)="saveNewFilter($event)"></core-file-page-filters>
        </div>

    </div>
</div>
